import type { FixedLadderStep } from '../../../api/client';

/** A rung while editing: the persisted shape plus a client-only `uid` used as a
 * stable React key (steps have no id of their own — order is identity). */
export interface DraftStep extends FixedLadderStep {
  uid: string;
}

let _uidCounter = 0;
export function newUid(): string {
  _uidCounter += 1;
  return `rung-${_uidCounter}-${Math.random().toString(36).slice(2, 8)}`;
}

export function toDraft(step: FixedLadderStep): DraftStep {
  // Normalise offer_framing to a string so the editor textarea stays controlled;
  // it's persisted back only when non-blank (sale rungs), else dropped.
  return { ...step, preview_ids: step.preview_ids ?? [], offer_framing: step.offer_framing ?? '', uid: newUid() };
}

export function emptyStep(type: 'teasing' | 'sale'): DraftStep {
  return {
    uid: newUid(),
    label: '',
    type,
    content_ids: [],
    content_vaults: {},
    price: 0,
    min_price: 0,
    preview_ids: [],
    offer_framing: '',
  };
}
